import simpleRestDataProvider from "@refinedev/simple-rest";
import { getAdminEnvironmentConfig } from "../services/adminEnvironment";
import { chatbotAdminApi } from "./chatbotAdminApi";
import { springAdminApi } from "./springAdminApi";

const fallbackProvider = simpleRestDataProvider(
  getAdminEnvironmentConfig().apiBaseUrl,
  springAdminApi,
);

const fieldValue = (filters: any[], field: string) =>
  filters.find((filter) => "field" in filter && filter.field === field)?.value;

const filterValue = (filters: any[], field: string, operator: string) =>
  filters.find((filter) => "field" in filter && filter.field === field && filter.operator === operator)?.value;

const chatbotDataProvider = {
  ...fallbackProvider,
  getList: async ({ resource, pagination, filters }: any) => {
    if (resource === "message_templates") {
      const response = await chatbotAdminApi.listTemplates();
      return { data: response.data.data, total: response.data.data.length };
    }

    const allFilters = filters ?? [];
    const status = fieldValue(allFilters, "appraisal_status_id");
    const statusValues = Array.isArray(status) ? status : status == null ? [] : [status];
    const startDate = filterValue(allFilters, "created_at", "gte");
    const endDate = filterValue(allFilters, "created_at", "lte");
    const response = await chatbotAdminApi.list({
      status_id: statusValues.length ? statusValues.join(",") : undefined,
      q: fieldValue(allFilters, "user_name"),
      page: pagination?.current,
      page_size: pagination?.pageSize,
      start_date: typeof startDate === "string" ? startDate.slice(0, 10) : undefined,
      end_date: typeof endDate === "string" ? endDate.slice(0, 10) : undefined,
    });
    return {
      data: response.data.data,
      total: response.data.pagination?.total_items ?? response.data.data.length,
    };
  },
  getOne: async ({ resource, id }: any) => {
    const response = await chatbotAdminApi.get(id);
    return { data: response.data.data };
  },
  update: async ({ resource, id, variables }: any) => {
    const response = await chatbotAdminApi.update(id, variables);
    return { data: response.data.data };
  },
  create: async ({ resource, variables }: any) => {
    if (resource !== "message_logs") {
      throw new Error(`Unsupported chatbot create resource: ${resource}`);
    }
    const response = await chatbotAdminApi.sendMessage(variables.apply_onda_id, {
      msg_template_id: variables.msg_template_id,
      text: variables.text,
    });
    return { data: response.data.data };
  },
} as any;

export default chatbotDataProvider;
